/* fl-set-auswahl.js (19.10.2026): Kachelwechsel zwischen Basis / Set X300 / Set X500 (snippets/fl-variant-family.liquid).
   Ersetzt das Skript der Sektion bundle-picker-variants (rund 600 Zeilen, vier Zustandsspeicher, MageWorx-Pfade). Was mitgenommen wird:
   - die GROESSE: jede Kachel traegt die Nummern und die erste Option ihrer Varianten (data-fl-set-ids/-opt/-av); der Link bekommt
     ?variant=<Variante gleicher Groesse>, sonst die erste lieferbare. Die Links werden beim Laden und bei jeder Aenderung der
     Auswahl aktualisiert, damit auch Mittelklick, "Link kopieren" und das Vorabladen (speculationrules) die richtige Adresse haben.
   - FARBTON und GLANZGRAD (eigene Auswahl, window.flFarbton): beim Klick merkt sich sessionStorage EINEN Satz {Ziel, Zeit, Farbton,
     Glanz}; die Zielseite liest ihn genau einmal, nur wenn das Ziel stimmt und er jünger als 2 Minuten ist, und setzt ihn mit
     flFarbton.setzen(..., 'set'). Rang: Kunde > Adresse > diese Mitnahme > Besuch (assets/product-form-farbton.js).
   Auf einer Seite ohne Farbton-Auswahl (Produkt ohne Tag) wird nur die Groesse mitgenommen. */
(function () {
  'use strict'
  var wurzel = document.querySelector('[data-fl-set-auswahl]')
  if (!wurzel) return
  var KEY = 'fl-set-wahl'
  var AKTUELL = wurzel.getAttribute('data-fl-set-aktuell')
  var KACHELN = [].slice.call(wurzel.querySelectorAll('[data-fl-set-handle]'))
  var SEKUNDEN = 120

  function liste (el, name) {
    try { var l = JSON.parse(el.getAttribute(name) || '[]'); return Array.isArray(l) ? l : [] } catch (e) { return [] }
  }
  function kachelVon (handle) {
    for (var i = 0; i < KACHELN.length; i++) if (KACHELN[i].getAttribute('data-fl-set-handle') === handle) return KACHELN[i]
    return null
  }

  // Nummer der gewaehlten Variante: Adresse zuerst, sonst das Feld des Formulars (wie die alte Sektion).
  function gewaehlteVariante () {
    var v = new URLSearchParams(window.location.search).get('variant')
    if (v) return String(v)
    var f = document.querySelector('[id^="product-form-"][id$="__main"] input[name="id"]') || document.querySelector('input[name="id"][form$="__main"]')
    return f && f.value ? String(f.value) : null
  }
  function groesseJetzt () {
    var eigene = kachelVon(AKTUELL)
    var id = gewaehlteVariante()
    if (!eigene || !id) return null
    var i = liste(eigene, 'data-fl-set-ids').map(String).indexOf(id)
    return i < 0 ? null : liste(eigene, 'data-fl-set-opt')[i]
  }
  // gleiche Groesse und lieferbar, sonst die erste lieferbare, sonst die erste (wie die alte Sektion)
  function varianteFuer (kachel, groesse) {
    var ids = liste(kachel, 'data-fl-set-ids')
    var opt = liste(kachel, 'data-fl-set-opt')
    var av = liste(kachel, 'data-fl-set-av')
    var i
    if (!ids.length) return null
    for (i = 0; i < ids.length; i++) if (opt[i] === groesse && av[i] !== false) return ids[i]
    for (i = 0; i < ids.length; i++) if (av[i] !== false) return ids[i]
    return ids[0]
  }

  var letzte = null
  function aktualisieren () {
    var g = groesseJetzt()
    if (g === letzte && letzte !== null) return
    letzte = g
    KACHELN.forEach(function (k) {
      if (k.tagName !== 'A') return
      var id = g == null ? null : varianteFuer(k, g)   // Groesse unbekannt: die Adresse bleibt sauber
      try {
        var u = new URL(k.getAttribute('href'), window.location.href)
        if (id) u.searchParams.set('variant', id); else u.searchParams.delete('variant')
        k.setAttribute('href', u.pathname + u.search)
      } catch (e) { /* Adresse unlesbar: der Link bleibt, wie er ist */ }
    })
  }
  var timer = null
  function spaeter () { clearTimeout(timer); timer = setTimeout(aktualisieren, 150) }

  // ---- Farbton und Glanzgrad ---------------------------------------------------------
  function merken (ziel) {
    var s = { z: ziel, t: Date.now(), f: '', g: '' }
    try {
      var st = window.flFarbton && window.flFarbton.lesen ? window.flFarbton.lesen() : null
      if (st) { s.f = st.farbton || ''; s.g = st.glanz || '' }
      window.sessionStorage.setItem(KEY, JSON.stringify(s))
    } catch (e) { /* privater Modus: die Mitnahme entfaellt, der Wechsel nicht */ }
  }
  function setzen (werte) {
    if (window.flFarbton && typeof window.flFarbton.setzen === 'function') { window.flFarbton.setzen(werte, 'set'); return }
    var root = document.querySelector('[data-fl-farbton]')
    if (root) root.setAttribute('data-fl-set', JSON.stringify(werte))   // product-form-farbton.js liest das beim Start
  }
  function wiederherstellen () {
    var roh = null
    try { roh = window.sessionStorage.getItem(KEY); window.sessionStorage.removeItem(KEY) } catch (e) { return }
    var s = null
    try { s = JSON.parse(roh) } catch (e) { return }
    if (!s || s.z !== AKTUELL || !(Date.now() - s.t >= 0 && Date.now() - s.t < SEKUNDEN * 1000)) return
    if (s.f || s.g) setzen({ farbton: s.f, glanz: s.g })
  }

  wurzel.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[data-fl-set-handle]') : null
    if (!a) return
    aktualisieren()
    merken(a.getAttribute('data-fl-set-handle'))
  })
  document.addEventListener('change', spaeter, true)
  document.addEventListener('click', spaeter, true)
  window.addEventListener('pageshow', function () { letzte = null; aktualisieren() })

  function aktiviert (f) {
    if (document.prerendering) document.addEventListener('prerenderingchange', f, { once: true })
    else f()
  }
  aktualisieren()
  aktiviert(wiederherstellen)
})()
